export enum LearnerActivityType {
  COURSE = 'COURSE',
  LESSON = 'LESSON',
  GADGET = 'GADGET',
}
